<template lang="pug">
.popup
  .wrapper
    .title {{title}}
    .btns
      .no.btn(@click="$emit('no')") 否
      .yes.btn(@click="$emit('yes')") 是
    
  
</template>
<script>
export default {
  name: 'Popup',
  props: {
    title: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.popup
  position: fixed
  width: 100%
  height: 100%
  z-index: 9999
  top: 0
  left: 0
  +flex-center
  background: rgba(0, 0, 0, 0.46)
  .wrapper
    width: pxToRem(560)
    //height: pxToRem(229)
    background: white
    border-radius: pxToRem(20)
    .title
      width: 100%
      padding: pxToRem(40)
      font-size: pxToRem(36)
      color: black
      border-bottom: 1px rgba(102, 102, 102, 0.15) solid
    .btns
      width: 100%
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      .btn
        width: 50%
        padding: pxToRem(25) pxToRem(40)
        font-size: pxToRem(36)
        text-align: center
        color: #1664FF
        &:first-child
          border-right: 1px rgba(102, 102, 102, 0.15) solid
        &:last-child
          font-weight: bold
</style>
